import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const KIOSKLOYALTYCONNECTIONPAGE_LEGACY_FIELD_ORDER = [
  "background_color",
  "background_image",
  "text_color"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  kioskLoyaltyConnectionPageDescriptor: _generatedKioskLoyaltyConnectionPageDescriptor,
  kioskLoyaltyConnectionPageBlocDefinition,
  kioskLoyaltyConnectionPageDashboardLayout,
  kioskLoyaltyConnectionPageConfig,
  kioskLoyaltyConnectionPageResolveConfig,
  kioskLoyaltyConnectionPageProperties,
} = doodBlockConfig(
  {
    name: "Kiosk - Loyalty connection page",
    internal_name: "Kiosk - Loyalty connection page",
    url: "loyalty",
    defaultParent: [/^Main Layout$/i],
    componentType: 'KioskLoyaltyConnectionPageComponent',
    category: 'page',
    description: "Kiosk - Loyalty connection page.",
    keywords: [],
    isRootBlock: true,
    sharedFields: {}
,
    slots: [
      {
        key: 'header',
        name: "pages.blocks.kiosk-loyalty-connection-page.header.label",
        accept: 'explicitOnly',
        allowedTypes: ["KioskHeaderBlock"],
        slotItemFormat: 'ids',
      },
      {
        key: 'body',
        name: "pages.blocks.kiosk-loyalty-connection-page.body.label",
        accept: 'explicitOnly',
        allowedTypes: ["KioskLoyaltyConnectionBlock"],
        slotItemFormat: 'ids',
      },
      {
        key: 'footer',
        name: "pages.blocks.kiosk-loyalty-connection-page.footer.label",
        accept: 'explicitOnly',
        allowedTypes: ["KioskDoubleButtonFooterBlock"],
        slotItemFormat: 'ids',
      }
    ]
  },

  () => ({
    background_color: propertyValue({
      type: 'color',
      value: {"type":"hex","value":"#FFFFFF"},
      options: {
        label: "pages.blocks.kiosk-loyalty-connection-page.background-color.label",
      }
    }),
    background_image: propertyValue({
      type: 'image',
      value: '',
      options: {
        label: "pages.blocks.kiosk-loyalty-connection-page.background-image.label",
        help: "pages.blocks.kiosk-loyalty-connection-page.background-image.help",
      }
    }),
    text_color: propertyValue({
      type: 'color',
      value: {"type":"hex","value":"#000"},
      options: {
        label: "pages.blocks.kiosk-loyalty-connection-page.text-color.label",
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.kiosk-loyalty-connection-page.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.kiosk-loyalty-connection-page.fieldset.appearance.label",
            fields: ["background_color", "background_image", "text_color"],
          },
          {
            legend: "pages.blocks.kiosk-loyalty-connection-page.fieldset.blocks.label",
            fields: ["header", "body", "footer"],
          },
        ],
      },
    ],
  })
);

export function kioskLoyaltyConnectionPageDescriptor(): IBlockDescriptor;
export function kioskLoyaltyConnectionPageDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function kioskLoyaltyConnectionPageDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedKioskLoyaltyConnectionPageDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedKioskLoyaltyConnectionPageDescriptor, kioskLoyaltyConnectionPageProperties, fieldOrder);
}

export {
  kioskLoyaltyConnectionPageBlocDefinition,
  kioskLoyaltyConnectionPageDashboardLayout,
  kioskLoyaltyConnectionPageProperties,
  kioskLoyaltyConnectionPageConfig,
  kioskLoyaltyConnectionPageResolveConfig,
};

export type KioskLoyaltyConnectionPageConfig = typeof kioskLoyaltyConnectionPageConfig;
